"use client";

import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Ban, X } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "./lib/utils";

type BlockedPhonePopupProps = {
  open: boolean;
  message?: string;
  onClose: () => void;
};

const DEFAULT_MESSAGE =
  "This mobile number is blocked by admin and cannot be added.";

export const BlockedPhonePopup: React.FC<BlockedPhonePopupProps> = ({
  open,
  message,
  onClose,
}) => {
  return (
    <DialogPrimitive.Root
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay
          className="fixed inset-0 z-[110] bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-[111] grid w-full max-w-sm translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-white p-6 shadow-lg duration-200",
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          )}
          onPointerDownOutside={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
            <Ban className="h-6 w-6 text-red-600" />
          </div>
          <DialogPrimitive.Title className="text-center text-lg font-semibold text-gray-900">
            Number blocked
          </DialogPrimitive.Title>
          <DialogPrimitive.Description className="text-center text-sm text-gray-600">
            {message?.trim() || DEFAULT_MESSAGE}
          </DialogPrimitive.Description>
          <Button type="button" className="mt-2 w-full" onClick={onClose}>
            OK
          </Button>
          <DialogPrimitive.Close
            className="absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default BlockedPhonePopup;
